function getFirstFromIterable(set) {
  return set.values().next().value;
}
export {
  getFirstFromIterable
};
//# sourceMappingURL=iterable.mjs.map
